import React from 'react';
import PropTypes from 'prop-types';
import template from '../../../../templates/Stones/AssignPricing/PricingPresets/editPreset.rt';
import { connect } from 'react-redux';
import * as actions from '../../../../actions';
import * as PricingPresetDataTypes from '../../../../constants/pricingPresets';
import * as helpers from '../../../../utilities/helpers';
import $ from 'jquery';
import {AVAILABLE_PRICES, getPresetUpdateProperty} from "../../../../reducers/pricingPreset";

const LINE_LENGTH = 150; //units (sqft/lnft/etc)
const DEFAULT_LENGTHS = {
  SQUARE_FOOT: 18,
  SLAB: 18,
  PACKAGE: 36,
  MINIMUM: 18
};

function mapStateToProps(state, props) {
  const { selectedPreset, applyToPrice } = state.pricingPreset;
  const {customerInfo} = state.newaccount;
  let hasSlabModeEnabled = false;
  if(customerInfo) {
    hasSlabModeEnabled = customerInfo.toolSettings.kitchen.showSlabMode || customerInfo.toolSettings.kitchen.showSlabModeDashboard;
  }
  return {
    applyToPrice,
    preset: selectedPreset,
    LINE_LENGTH,
    DEFAULT_LENGTHS,
    hasSlabModeEnabled
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    setValue: (field, value) => dispatch(actions.pricingPresets.updateValue(field, value)),
    alert: (title, message, type, callback) => dispatch(actions.messageBox_Show(true, type || 'system', title, message, [{
      text: 'Yes',
      subtext: 'I would like to continue',
      onClick: () => {
        dispatch(actions.messageBox_Show()); //reset to default props (not visible by default)
        if (callback) {
          callback();
        }
      }
    }, {
      text: 'No',
      subtext: 'leave everything as it is',
      onClick: () => dispatch(actions.messageBox_Show())
    }]))
  };
}

export const defaultData = {
  type: PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG,
  start: 0,
  end: LINE_LENGTH,
  value: 0
};

const getPresetStateData = (preset, applyToPrice = AVAILABLE_PRICES) => {
  const property = getPresetUpdateProperty(applyToPrice);
  return Array.isArray(preset[property]) && preset[property].length
    ? [...preset[property].map(dataObject => Object.assign({}, dataObject))] // keep in a new array
    : [{ ...defaultData }];
}

class editPreset extends React.Component {
  render = template;
  constructor(props) {
    super(props);
    this.state = {
      ...this.props.preset,
      data: getPresetStateData(this.props.preset, this.props.applyToPrice),
      selected: null,
    };
  }
  componentDidMount(fromData = this.state.data) {
    const defaultIndex = (fromData[0].type === PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG) ? 0 : 1;
    this.setSelected(fromData[defaultIndex], fromData);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.applyToPrice !== this.props.applyToPrice) {
      const nextData = getPresetStateData(nextProps.preset, nextProps.applyToPrice);
      this.setValue('data', nextData);
      this.componentDidMount(nextData);
    }
  }

  getCurrencySymbol = () => helpers.getCurrencySymbol(this.state.currency);
  getPriceElement = (price) => {
    return (
      <span><span style={{fontFamily: 'playregular'}}>{this.getCurrencySymbol()}</span>{price}</span>
    );
  }

  hasRoom = () => findGaps(this.state.data).foundGap;

  /**
   * Add a Data Segment to the Data Array
   * @param {constants pricingPresets.PRICING_PRESET_(SQFT/SLAB/PKG/MIN)_SEG} type
   */
  addDataSeg = (type) => {
    let start = 0,
      data = this.state.data || [];
    if (
      this.state.data.length > 0 &&
      this.state.data[0].type !== type && (
        type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ||
        type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG
      )) {
      this.props.alert(
        "Changing Base Pricing Type",
        "This change will remove all pricing from this preset. Are you sure you wish to continue?",
        'system',
        () => {
          let selected = null;
          switch (type) {
            case PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG:
              data = [{ ...defaultData }];
              break;
            case PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG:
              data = [{
                type: PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG,
                start: 0,
                end: DEFAULT_LENGTHS.SLAB
              }];
              selected = data[0];
              break;
          }
          this.setState({ data: data }, () => this.setSelected(data[0]));
        }
      );
      return;
    }
    for (let i = 0; i < data.length; i++) {
      if (i >= 1 && start < data[i].end && data[i].end != Infinity) {
        start = data[i].end;
      }
    }
    let end = start + DEFAULT_LENGTHS.SQUARE_FOOT,
      push = true,
      newSeg = null;
    switch (type) {
      case PricingPresetDataTypes.PRICING_PRESET_PLUS_SQFT_SEG:
      case PricingPresetDataTypes.PRICING_PRESET_PLUS_PKG_SEG:
        if (!this.hasRoom() || !this.state.selected || this.state.selected.index == 0 ) { return; }
        if(
          (type == PricingPresetDataTypes.PRICING_PRESET_PLUS_SQFT_SEG && this.state.selected.type !== PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG) ||
          (type == PricingPresetDataTypes.PRICING_PRESET_PLUS_PKG_SEG && this.state.selected.type !== PricingPresetDataTypes.PRICING_PRESET_PKG_SEG) ||
          ( this.state.data.length > this.state.selected.index + 1 && (
              this.state.data[this.state.selected.index + 1].type == PricingPresetDataTypes.PRICING_PRESET_PLUS_PKG_SEG ||
              this.state.data[this.state.selected.index + 1].type == PricingPresetDataTypes.PRICING_PRESET_PLUS_SQFT_SEG
          ))
        ) {
          return;
        }
        start = this.state.selected.end;
        end = start + DEFAULT_LENGTHS.SQUARE_FOOT;
        if(end > LINE_LENGTH) {
          end = Infinity;
        }
        newSeg = {
          type,
          start,
          end
        };
        if(this.state.data.length - 1 === this.state.selected.index) {
          data.push(newSeg);
        } else {
          data.splice(this.state.selected.index + 1, 0, newSeg);
        }
        push = false;
        break;
      case PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG:
        if (!this.hasRoom()) { return; }
        end = start + DEFAULT_LENGTHS.SQUARE_FOOT;

        if(this.state.data.length === 1) {
          end = Infinity;
        }
        break;
      case PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG:
        end = start + DEFAULT_LENGTHS.SQUARE_FOOT;
        return;
        break;
      case PricingPresetDataTypes.PRICING_PRESET_PKG_SEG:
        if (this.state.data[0].type !== PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG || !this.hasRoom()) {
          return;
        }
        end = start + DEFAULT_LENGTHS.PACKAGE;
        break;
      case PricingPresetDataTypes.PRICING_PRESET_MIN_SEG:
        if (this.state.data[0].type !== PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG || !this.hasRoom() || (this.state.data.length > 1 && this.state.data[1].type === PricingPresetDataTypes.PRICING_PRESET_MIN_SEG)) {
          return;
        }
        start = 0;
        end = DEFAULT_LENGTHS.SQUARE_FOOT;
        if (data.length >= 2) {
          if (data[1].start > 0) {
            end = data[1].start;
          }
        }
        newSeg = {
          type,
          start,
          end
        };
        data.splice(1, 0, newSeg);
        push = false;
        break;
    }
    if (push) {
      if (end >= LINE_LENGTH) {
        end = Infinity
      };
      newSeg = {
        type,
        start,
        end
      };
      data.push(newSeg);
    }

    data = this.reAlignSegments(data);
    this.setSelected(newSeg);
    this.setValue('data', data);
  }

  /**
   * Re-Aligns Segments to fill space available
   * @param {array} segments
   */
  reAlignSegments = (segments) => {
    let curEnd = segments[1].end;
    for (let i = segments.length - 1; i > 0; i--) {
      if (segments[i].type === PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG && segments[i].end == Infinity) {
        var seg = segments.splice(i, 1);
        segments.push(seg[0]); //move this segment to the end, always.
        break;
      }
    }
    let prevEnd = null;
    for (let i = 2; i < segments.length; i++) {
      if (segments[i].start < curEnd && curEnd !== Infinity) {
        if (segments[i].end === Infinity) {
          segments[i].start = curEnd;
          curEnd = Infinity;
        } else {
          var diff = segments[i].end - segments[i].start;
          segments[i].start = curEnd;
          segments[i].end = curEnd = segments[i].start + diff;
        }
      } else {
        curEnd = segments[i].end;
      }
    }
    return segments;
  }
  /**
   * Removes Segment by Index from Data Array
   * @param {int} index
   */
  removeDataSeg = (index) => {
    let data = this.state.data || [];
    let prevEnd = data[index - 1].end;
    if(data[index].start == 0) {
      prevEnd = 0;
    }
    if (data.length > index) {
      data.splice(index, 1);
      while (
        data.length > index && (
        data[index].type == PricingPresetDataTypes.PRICING_PRESET_PLUS_PKG_SEG || data[index].type == PricingPresetDataTypes.PRICING_PRESET_PLUS_SQFT_SEG
      )) {
        data.splice(index, 1);
      };
    }
    for (var i = index; i < data.length; i++) {
      if(i == data.length - 1 && data[i].end == Infinity && data[i].start - diff != prevEnd)
        continue;
      let diff = data[i].end - data[i].start;
      data[i].start = prevEnd;
      data[i].end = data[i].start + diff;
      prevEnd = data[i].end;
    }
    this.setValue('data', data);
    this.setState({selected: null});
  }
  /**
   * Sets Segment Value
   * @param {string} prop
   * @param {object} value
   */
  setValue = (prop, value) => {
    this.setState({ [prop]: value });
    if (this._setValueTimeout) window.clearTimeout(this._setValueTimeout);
    this._setValueTimeout = window.setTimeout(() => this.props.setValue(prop, value), 500);
  }
  /**
   * Sets Selected Segment
   * @param {object} value
   * @param {array} data
   */
  setSelected = (value, data = this.state.data) => {
    let selected = {index: data.indexOf(value), ...value};
    this.setState({selected}, () => {
      $('.algorithm-properties-input').focus();
    });
  }
  /**
   * Returns array of segments for slab pricing
   * @param {object[]} data
   * @returns {object[]}
   */
  getSlabSegments = (data) => {
    let segmentCount = Math.floor((LINE_LENGTH - (LINE_LENGTH / 100 * 5)) / data.end),
      segments = [];

    for (var i = 0; i < segmentCount; i++) {
      var segment = { ...data };
      segment.start = segment.end * i;
      segment.end = segment.start + segment.end;
      segments.push(segment);
    }
    return segments;
  }
  /**
   * Check if minimum should be disabled
   * @returns {bool}
   */
  isMinimumDisabled = () => {
    var disabled = this.state.data[0].type !== PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG;
    var minExists = false;

    for (var i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i].type === PricingPresetDataTypes.PRICING_PRESET_MIN_SEG) {
        minExists = true;
        break;
      }
    }

    return disabled || minExists;
  }
  /**
   * Update Selected Segment Price
   * @param {int} index
   */
  updateSelectedValue = (index) => {
    let data = this.state.data,
      selected = this.state.selected,
      value = this.selectedValueInput.value;

    value = value.replace(/[^0-9\.]/g, '');

    data[index].value = value;
    selected.value = value;
    this.setValue('data', data);
    this.setState({'selected': selected});
  }
  /**
   * Update Slab sqft price
   * @param {decimal} value
   */
  updateSelectedSlabSQFTValue = (value) => {
    let data = this.state.data,
      selected = this.state.selected;

    value = value.replace(/[^0-9\.]/g, '');

    data[0].slabSqftValue = value;
    selected.slabSqftValue = value;
    this.setValue('data', data);
    this.setState({'selected': selected});
  }
  /**
   * return Adjusted value after compensating for min/max allowed values
   * @param {object} input
   * @returns {int}
   */
  getAdjustedValueForMinMax = (input) => {
    let val = input.value,
      max = input.getAttribute('max') || Infinity,
      min = input.getAttribute('min') || 0;

    val = Math.max(Math.min(val, max), min);

    if(val >= LINE_LENGTH) {
      val = Infinity;
    } if(val < 0) {
      val = 0;
    }
    return val;
  }
  /**
   * Gets Min/Max values for data Segment by index
   * @param {int} index
   */
  getMinMax = (index) => {
    const {data} = this.state;
    let prev = data[index - 1],
      next = data[index + 1],
      node = data[index];

    if(!node) {
      return {
        start: {
          min: 0,
          max: Infinity
        }, end: {
          min: 0,
          max: Infinity
        }
      };
    }

    if(!next) {
      next = {
        start: node.end,
        end: Infinity
      };
    }
    if (!prev) {
      prev = {
        start: 0,
        end: node.start
      };
    }

    return {
      start: {
        min: (prev.start === 0 && prev.end === LINE_LENGTH) ? 0 : prev.start + 1,
        max: node.end - 1
      },
      end: {
        min: node.start + 1,
        max: next.end - 1
      }
    };
  }
  /**
   * Returns if data segment is selected
   * @param {object} data
   * @returns {bool}
   */
  isSelected = (data) => {
    return this.state.selected && this.state.selected.index == this.state.data.indexOf(data);
  }
  /**
   * Enforces Min/Max restrictions on input box
   * @param {React Event} e
   * @param {constants pricingPresets.PRICING_PRESET_(SQFT/SLAB/PKG/MIN)_SEG} type
   */
  enforceMinMax = (e, type) => {
    let val = this.getAdjustedValueForMinMax(e.target),
      data = [...this.state.data],
      index = this.state.selected.index;

    if(data[index].type != PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG) {
      if(index >= 1 && type == 'start') {
        if(data[index - 1].end == data[index].start) {
          data[index - 1].end = val;
        }
      }
      if(index < data.length - 1 && type == 'end') {
        if(data[index + 1].start == data[index].end) {
          data[index + 1].start = val;
        }
      }
    }

    data[index][type] = val;
    this.setValue('data', data);
    this.setSelected(data[index]);
  }
  setInfinity = () => {
    let data = [...this.state.data],
      index = this.state.selected.index;

    data[index].end = Infinity;
    this.setValue('data', data);
    this.setSelected(data[index]);
  }
  /**
   * Sets Selected Segment's Start Value
   * @param {int} val
   */
  setSelectedStartValue = (val) => {
    let selected = this.state.selected;
    selected.start = val;

    this.setState({selected});
  }
  /**
   * Sets Selected Segment's End Value
   * @param {int} val
   */
  setSelectedEndValue = (val) => {
    let selected = this.state.selected;
    selected.end = val;

    this.setState({selected});
  }
  /**
   * gets unique start/end points in an array
   * @returns {int[]}
   */
  getUniquePoints = () => {
    let points = [];
    if(this.state.data[0].type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG) {
      for(let index in this.state.data) {
        let data = this.state.data[index]
          , start = data.start
          , end = data.end;
        if(end == Infinity || end >= LINE_LENGTH) {
          end = LINE_LENGTH;
        }
        if(points.indexOf(start) == -1) {
          points.push(start);
        }
        if(points.indexOf(end) == -1) {
          points.push(end);
        }
      }
    } else {
      for(let index = 0; index <= LINE_LENGTH; index += this.state.data[0].end) {
        points.push(index);
      }
    }
    points.sort();
    return points;
  }
}

editPreset.propTypes = {
  toPage: PropTypes.func.isRequired
};

const EditPreset = connect(mapStateToProps, mapDispatchToProps)(editPreset);

export default EditPreset;

/**
* Find gap in a segment data array
* @param data {array}
* @returns object {foundGap {bool}, gaps {from: {number}, to: {number}}}
*/
export const findGaps = (data) => {
 let foundGap = true;
 var gaps = [];
 if (data[0].type === PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG && data.length > 1) {
   foundGap = false;
   var prevEnd = 0;
   for (let i = 1; i < data.length; i++) {
     if (prevEnd < data[i].start) {
       foundGap = true;
       gaps.push({from: prevEnd, to: data[i].start});
     }
     prevEnd = data[i].end;
   }
   if (data[data.length - 1].end !== Infinity && data[data.length - 1].end < LINE_LENGTH) {
     foundGap = true;
     gaps.push({from: data[data.length - 1].end, to: Infinity});
   }
 }
 return { foundGap, gaps };
}
